/**
 * Stone card live figures.
 *
 * Fills the "Blocks" and "Available (m²)" cells of collection stone cards
 * (snippets/stone-product-card.liquid) from the FindMyMarble stone-types
 * endpoint -- ONE request per page, matched by data-stone-name.
 *
 * Fails silent: without the API, on error, or when a stone has no record,
 * the two cells stay hidden and the card keeps its server-rendered content.
 * Nothing is estimated or invented.
 */
(function () {
  'use strict';

  var apiUrl = window.__FINDMYMARBLE_API_URL;
  if (!apiUrl || typeof fetch !== 'function') return;
  apiUrl = String(apiUrl).replace(/\/+$/, '');

  var TIMEOUT_MS = 8000;
  var loading = null;
  var areaFormat = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 });

  function normalize(name) {
    return name ? String(name).trim().toLowerCase() : '';
  }

  function loadIndex() {
    if (loading) return loading;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, TIMEOUT_MS) : null;

    loading = fetch(apiUrl + '/api/shopify/stone-types', controller ? { signal: controller.signal } : undefined)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var index = {};
        var list = (data && data.stone_types) || [];
        for (var i = 0; i < list.length; i++) {
          var key = normalize(list[i].stone_name);
          if (key) index[key] = list[i];
        }
        return index;
      })
      .catch(function () {
        return {};
      })
      .then(function (index) {
        if (timer) clearTimeout(timer);
        return index;
      });

    return loading;
  }

  function reveal(cell) {
    var wrapper = cell.closest('[data-stone-card-cell]');
    if (wrapper) wrapper.hidden = false;
  }

  function fillCard(card, index) {
    if (card.getAttribute('data-stone-card-live') === 'done') return;
    card.setAttribute('data-stone-card-live', 'done');

    // STATIC products (owner directive 2026-09-03) are not fed from the live
    // stone inventory, so this script says nothing about them at all: no live
    // figures, no fading, no badge change. Marked in Liquid by
    // snippets/stone-product-card.liquid via snippets/stone-is-static.liquid.
    if (card.hasAttribute('data-stone-card-static')) return;

    var record = index[normalize(card.getAttribute('data-stone-name'))];
    if (!record) return;

    var blocks = Number(record.block_count);
    var sqm = Number(record.total_available_sqm);

    var blocksCell = card.querySelector('[data-stone-card-blocks]');
    if (blocksCell && isFinite(blocks) && blocks > 0) {
      blocksCell.textContent = String(blocks);
      reveal(blocksCell);
    }

    var sqmCell = card.querySelector('[data-stone-card-sqm]');
    if (sqmCell && isFinite(sqm) && sqm > 0) {
      sqmCell.textContent = areaFormat.format(sqm) + ' m²';
      reveal(sqmCell);
    }

    markOutOfStock(card, blocks);
  }

  /**
   * Out-of-stock view, SECONDARY trigger (2026-09-03, owner directive S3).
   *
   * The primary trigger is server-side: snippets/stone-product-card.liquid puts
   * .is-out-of-stock on the card when product.available is false, so the faded
   * card works with JavaScript off. This adds the same class when FindMyMarble
   * has a record for the stone and that record says zero blocks.
   *
   * Deliberately narrow: a MISSING record changes nothing (absence of data is
   * not a claim of zero), and the class is only ever added, never removed --
   * this function cannot make an unavailable stone look available.
   */
  function markOutOfStock(card, blocks) {
    if (!isFinite(blocks) || blocks !== 0) return;
    if (card.classList.contains('is-out-of-stock')) return;

    card.classList.add('is-out-of-stock');

    var status = card.querySelector('[data-stone-card-status]');
    if (!status) return;
    var label = status.getAttribute('data-oos-label');
    if (label) status.textContent = label;
    status.classList.remove('stone-card__status--enquire');
    status.classList.add('stone-card__status--oos');
  }

  function run(root) {
    var cards = (root || document).querySelectorAll('[data-stone-card]:not([data-stone-card-live])');
    if (!cards.length) return;
    loadIndex().then(function (index) {
      for (var i = 0; i < cards.length; i++) fillCard(cards[i], index);
    });
  }

  function start() {
    run(document);
    var grid = document.getElementById('product-grid');
    if (grid && typeof MutationObserver === 'function') {
      new MutationObserver(function () { run(grid); }).observe(grid, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
